import { render, staticRenderFns } from "./back-top.vue?vue&type=template&id=0dcb6448&scoped=true"
import script from "./back-top.vue?vue&type=script&lang=js"
export * from "./back-top.vue?vue&type=script&lang=js"
import style0 from "./back-top.vue?vue&type=style&index=0&id=0dcb6448&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb6448",
  null
  
)

export default component.exports